import { Grid, GridItem, Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type InboxLayoutProps = {
  left: ReactNode;
  middle: ReactNode;
  bottom: ReactNode;
};

export const InboxLayout = ({ left, middle, bottom }: InboxLayoutProps) => {
  return (
    <Grid
      templateColumns={{ base: '1fr', lg: '300px 1fr' }}
      gap="0"
      position="absolute"
      inset={0}
      bg="white"
      borderTop="1px solid"
      borderTopColor="gray.100"
      minW={0}
      minH={0}
      overflow="hidden"
    >
      {/* LEFT SIDE */}
      <GridItem
        minW={0}
        minH={0}
        overflow="hidden"
        bg="white"
        borderRightWidth={{ base: 0, lg: '1px' }}
        borderRightStyle="solid"
        borderRightColor="gray.200" 
      >
        {left}
      </GridItem>

      {/* RIGHT SIDE*/}
      <GridItem minW={0} minH={0} overflow="hidden" bg="white" borderLeftWidth="0">
        <Grid templateRows="1fr auto" h="full" minW={0} minH={0}>
          <GridItem minW={0} minH={0} overflow="auto" overscrollBehaviorY="contain">
            {middle}
          </GridItem>

          <GridItem borderTopWidth="1px" borderTopStyle="solid" borderTopColor="gray.100">
            <Box p="16px" minW={0}>
              {bottom}
            </Box>
          </GridItem>
        </Grid>
      </GridItem>
    </Grid>
  );
};
